import {
  nomenclatureCategorySchema,
  nomenclatureSchema,
  paginatedSchema,
  type CreateNomenclatureInput,
  type NomenclatureCategoryDto,
  type NomenclatureDto,
  type Paginated,
  type UpdateNomenclatureInput,
} from '@eombor/contracts';
import { apiClient } from '../../auth/model/auth.store.js';
import type { ApiClient } from '../../../shared/api/client.js';

/**
 * Katalog endpointlari. Manba:
 *   `catalog/infrastructure/http/catalog.controller.ts`
 *   `catalog/domain/nomenclature.ts` (`NomenclatureRow`, `CategoryRow`)
 *
 * Javob sxemalari `@eombor/contracts` dan olinadi va QAYTA yozilmaydi:
 * `nomenclatureSchema` allaqachon backend satrining aynan shakli. Shu tufayli
 * shartnoma o'zgarsa xato mana shu qatorda chiqadi, sahifa o'rtasida emas.
 */

const nomenclaturePageSchema = paginatedSchema(nomenclatureSchema);
const categoryPageSchema = paginatedSchema(nomenclatureCategorySchema);

export interface NomenclatureQuery {
  search?: string;
  categoryId?: string;
  page?: number;
  limit?: number;
}

export interface CategoryQuery {
  search?: string;
  page?: number;
  limit?: number;
}

export interface CatalogApi {
  list: (query?: NomenclatureQuery) => Promise<Paginated<NomenclatureDto>>;
  create: (input: CreateNomenclatureInput) => Promise<NomenclatureDto>;
  update: (id: string, input: UpdateNomenclatureInput) => Promise<NomenclatureDto>;
  /** 204 — hujjatlarda ishlatilgan mahsulot uchun 409 qaytadi. */
  remove: (id: string) => Promise<void>;
  listCategories: (query?: CategoryQuery) => Promise<Paginated<NomenclatureCategoryDto>>;
}

/** Bo'sh qiymat so'rovga QO'SHILMAYDI — `?search=` backendda 200 belgili satr tekshiruviga tushadi. */
const queryString = (query: NomenclatureQuery): string => {
  const params = new URLSearchParams({
    page: String(query.page ?? 1),
    limit: String(query.limit ?? 50),
  });
  if (query.search !== undefined && query.search !== '') params.set('search', query.search);
  if (query.categoryId !== undefined && query.categoryId !== '') {
    params.set('categoryId', query.categoryId);
  }
  return params.toString();
};

export const createCatalogApi = (client: ApiClient): CatalogApi => ({
  list: (query = {}) =>
    client.apiFetch(`/nomenclatures?${queryString(query)}`, { schema: nomenclaturePageSchema }),

  create: (input) =>
    client.apiFetch('/nomenclatures', {
      method: 'POST',
      body: JSON.stringify(input),
      schema: nomenclatureSchema,
    }),

  update: (id, input) =>
    client.apiFetch(`/nomenclatures/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(input),
      schema: nomenclatureSchema,
    }),

  remove: (id) => client.apiFetch(`/nomenclatures/${id}`, { method: 'DELETE' }),

  listCategories: (query = {}) =>
    client.apiFetch(`/categories?${queryString(query)}`, { schema: categoryPageSchema }),
});

export const catalogApi = createCatalogApi(apiClient);
